$(function () {
  var topButton = document.querySelector('#topbtn');
  var menu_fixed = document.querySelector('.menu_fixed.fixed');
  var menu_fixed2 = document.querySelector('.menu_fixed:nth-child(2) .common_blocks').cloneNode(true);
  ;
  var menu_fixedsp = document.querySelector('.menu_fixed.pc-none');
  var Menuinner = document.querySelector('.menu-content');
  var parentnav = document.querySelector('.commoncontetns-area');
  var headerslidebox = document.querySelector('.common_sildearea');
  var bured_area = document.querySelector('.bured_area');
  var headernavori = document.querySelector('.js_headnav_area');
  var headernav = document.querySelector('.js_headnav_area').cloneNode(true);
  var headernavPos = headernavori.getBoundingClientRect();
  var url = location.href.split('/');
  var topflag = false; // ウィンドウの高さを取得

  var winH = window.innerHeight;
  var winW = window.innerWidth; // ページの高さを取得

  var docH = document.documentElement.scrollHeight; // ウィンドウが最下部達した場合のウィンドウ上部の位置を取得

  var windBtm = docH - winH;
  var pos = 0;
  var lastPos = 0; //フロートするメニュー内にヘッダー要素をコピー

  menu_fixed.appendChild(menu_fixed2);
  menu_fixed.appendChild(headernav); //ナビの実際の高さ（どこでロードした場合でも）を取得

  var headernavPosY = headernavPos.top + window.pageYOffset; // ヘッダーの高さを取得

  var hH = menu_fixed.clientHeight;

  var onScroll = function onScroll() {
    if (pos > hH && pos > lastPos) {
      menu_fixed.classList.remove('active');
      menu_fixedsp.classList.add('active');
    } // スクロール位置がヘッダーの高さ分より小さいか
    // またはスクロール位置が最後のスクロール位置より小さい場合はclass名を削除


    if (pos < hH || pos < lastPos) {
      menu_fixed.classList.add('active');

      if (!Menuinner.classList.contains('active')) {
        menu_fixedsp.classList.remove('active');
      }
    }

    if (pos >= headernavPosY) {
      headernav.style.display = "block";
    } else {
      headernav.style.display = "none";
      menu_fixed.classList.remove('active');
      menu_fixedsp.classList.remove('active');
    } // 最後のスクロール位置を保存


    lastPos = pos; //スクロールが一番上に来たときの挙動

    if (url[3] === "") {
      if (pos <= 200) {
        menu_fixed.style.display = "none";
        menu_fixedsp.classList.remove('active');
      } else {
        menu_fixed.style.display = "block";
      }
    } else {
      if (pos <= 500) {
        menu_fixed.style.display = "none";
        menu_fixedsp.classList.remove('active');
      } else {
        menu_fixed.style.display = "block";
      }
    }
  };

  var humbergMenu = document.querySelector('.menu_fixed.pc-none .hamburger-menu'); // 	//ハンバーガーメニュークリック

  humbergMenu.addEventListener('click', function () {
    if (this.classList.contains('active')) {
      this.classList.remove('active');
      Menuinner.classList.remove('active');
    } else {
      Menuinner.classList.add('active');
      this.classList.add('active');
    }
  }); //スクロール値を取得

  function getScrolled() {
    return window.pageYOffset !== undefined ? window.pageYOffset : document.documentElement.scrollTop;
  } // smooth scroll


  var ua = window.navigator.userAgent.toLowerCase();

  if (!(ua.indexOf("mac os x") !== -1 && navigator.userAgent.match('Chrome/'))) {
    $('a[href^="#"]').click(function () {
      var speed = 500;
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      $("html, body").animate({
        scrollTop: position
      }, speed, "swing");
      return false;
    });
  }

  window.addEventListener("scroll", function () {
    getScrolled() > 600 ? topButton.classList.add('hiddn_top') : topButton.classList.remove('hiddn_top');
    pos = window.scrollY;
    onScroll(); //ptGet();
  });
  $('[data-fancybox]').fancybox({
    // オプションを下記に記載していきます
    loop: true,
    // 複数画像表示時に最初と最後をループさせる
    toolbar: true,
    // ツールバーの非表示
    smallBtn: true,
    // 小さいCloseボタン利用する
    iframe: {
      // iframe 関連の処理
      preload: false //iframeのプリロードをしない

    }
  }); // const modalArea = $('#modalArea');
  // console.log('modalArea:',modalArea)
  // $('.openModal').on('click',function(){
  // 	let btnnum = $('.openModal').index($(this));
  // 	let items = $('.modalContents').children(`.ss${btnnum}`);
  // 	$('.modalContents').prepend(items);
  // 	modalArea.fadeIn();
  // 	bodyScrollPrevent(true);
  // 	$('.single_sample').slick('setPosition');
  // });
  // $('#closeModal , #modalBg').on('click',function(){
  // 	modalArea.fadeOut(function(){
  // 		bodyScrollPrevent(false);
  // 	});
  // });
  // function bodyScrollPrevent(flag){
  // 	let scrollPosition;
  // 	const body = document.getElementsByTagName('body')[0];
  // 	const ua = window.navigator.userAgent.toLowerCase();
  // 	const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;
  // 	const scrollBarWidth = window.innerWidth - document.body.clientWidth;
  // 	if(flag){
  // 		body.style.paddingRight = scrollBarWidth + 'px';
  // 		if(isiOS){
  // 			scrollPosition = -window.pageYOffset;
  // 			body.style.position = 'fixed';
  // 			body.style.width = '100%';
  // 			body.style.top = scrollPosition + 'px';
  // 		} else {
  // 			body.style.overflow = 'hidden';
  // 		}
  // 	} else if(!flag) {
  // 		body.style.paddingRight = '';
  // 		if(isiOS){
  // 			scrollPosition = parseInt(body.style.top.replace(/[^0-9]/g,''));
  // 			body.style.position = '';
  // 			body.style.width = '';
  // 			body.style.top = '';
  // 			window.scrollTo(0, scrollPosition);
  // 		}else {
  // 			body.style.overflow = '';
  // 		}
  // 	}
  // }
}); // $(".single_sample").slick({
// 	slidesToShow :  1,
// 	slidesToScroll :  1,
// 	dots :  true,
// 	arrows:true,
// 	centerMode :  false,
// 	focusOnSelect :  true
// });